<template>
  <v-btn flat type="submit" color="primary" @click="refresh">
    <v-icon>refresh</v-icon>
  </v-btn>
</template>

<script>
import TransactionService from '../services/TransactionsService'
import SubscriptionsService from '../services/SubscriptionsService'
import WebhookLogsService from '../services/WebhookLogsService'

export default {
  name: 'Refresh',
  methods: {
    async refresh () {
      let collectionType = this.$route.name.toLowerCase()
      this.$store.commit('setDateRange', {})
      this.$store.commit('setSearchValue', null)
      this.$store.commit('setError', null)

      if (collectionType === 'transactions') {
        let response = await TransactionService.search({page: 1, limit: 20})
        this.$store.commit('setTransactions', response.data)
      } else if (collectionType === 'subscriptions') {
        let response = await SubscriptionsService.search({page: 1, limit: 20})
        this.$store.commit('setSubscriptions', response.data)
      } else if (collectionType === 'webhooklogs') {
        let response = await WebhookLogsService.search({page: 1, limit: 20})
        this.$store.commit('setWebhooklogs', response.data)
      } else {
        return false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Refresh.vue